import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";

import CreaDocumentacion from "../Modals/crear/CreaDocumentacion";
import Cookies from "universal-cookie";
import { documentacionPorSolicitud } from "../../Services/Rest";
import { useParams } from "react-router-dom";
import { descargarDocumento } from "../Seguridad/DescargarDocumento";

const cookie = new Cookies();

function InfoAnexosEvaluador(props) {
  let { id } = useParams();

  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: documentacionPorSolicitud + id,
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);

  return (
    <Fragment>
      <div className="container">
        <div className="text-left">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">Documentos</h6>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Archivo</th>
                        <th>Estado</th>
                        <th>Año</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.id}</td>
                            <td>{item.nombre}</td>
                            <td>
                              <button
                                className="btn btn-success"
                                onClick={() => descargarDocumento(item.archivo)}
                              >
                                Descargar: {item.archivo}
                              </button>
                            </td>

                            {item.estado == 0 ? (
                              <td>{"sin aprobar"}</td>
                            ) : (
                              <td>{"aprobado"}</td>
                            )}
                            <td>{item.fechaCorte}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default InfoAnexosEvaluador;
